/**
 * This file is part of the EXP project.
 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 * Date: 10.01.15
 * Time: 3:07
 */

// Keep small extensions and helper functions here.

;(function($) {

  /**
   * Checking image for existing by url.
   *
   * @param url
   * @returns {boolean}
   */
  jQuery.imageExists =  function(url){

    if(null == url || undefined == url){
      return false;
    }

    var image = $('<img src="' + url + '" />');
    return image.prop('width') > 0;
  };

  /**
   * Get url from background
   *
   * @returns {XML|string|jQuery}
   */
  jQuery.fn.parseUrlFromBackground = function (){
    var background = $(this).css('background-image');

    if(undefined == background){
      return null;
    }

    return background.replace('url("','').replace('")','');
  };

  /**
   * Format function. Usage 'Hello, {0}!'.format('Alex'); Output 'Hello, Alex!'
   *
   * @returns String
   */
  String.prototype.format = function() {
    var s = this,
        i = arguments.length;

    while (i--) {
      s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
  };

  /**
   * Update property by path.
   * Have var hash = {a:{a: 'optionONE'}} n
   * Need to change 'optionOne' to 'optionTwo'.
   * Call updatePropertyByPath(hash, 'a.a', 'optionTwo');
   *
   * @returns {Object}
   */
  function updatePropertyByPath (object, path, value){
    var i, tmp;
    var parts = path.split('.');

    for(i = 0; i < parts.length; i++) {
      tmp = object[parts[i]];
      if(value !== undefined && i == parts.length - 1) {
        tmp = object[parts[i]] = value;
      }
      else if(tmp === undefined) {
        tmp = object[parts[i]] = {};
      }
      object = tmp;
    }
    return object;
  }

  /**
   *
   * @param uri
   * @param key
   * @param value
   * @return {*}
   */
  $.updateQueryStringParameter = function(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  };

  /**
   * Works like php ucfirst() function
   *
   * @param {string} str
   * @returns {string}
   */
  $.ucfirst = function(str) {
    var f = str.charAt(0).toUpperCase();
    return f + str.substr(1, str.length-1);
  };

  /**
   *
   * @param {String} str
   * @param {String} [charlist]
   * @return {XML|void|*|string}
   */
  function rtrim(str, charlist) {
    charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
    var re = new RegExp('[' + charlist + ']+$', 'g');
    return str.replace(re, '');
  }

  /**
   * Display twitter bootstrap alert.
   *
   * @param {String}  message
   * @param {String}  type
   * @param {int}     [delay] Delay in ms before alert will dismissed.
   * If delay is not defined, alert will not dismiss automatically.
   *
   * @param {String}  [insertMethod] possible values is 'prepend' and 'after'.
   * Default value is 'prepend'
   *
   * @param {String}  [customClass]
   * @param {boolean}  [showClose]
   */
  jQuery.fn.showAlert = function(message, type, delay, insertMethod, customClass, showClose) {
    showClose = typeof undefined == typeof showClose ? true : showClose;

    var container   = $(this);
    var alertClass  = 'display-none alert alert-dismissible alert-{0}'.format(type);
    var closeButton = $('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');

    insertMethod = insertMethod || 'prepend';

    if(customClass) {
      alertClass += ' {0}'.format(customClass);
    }

    if(0 == container.length) {
      return false;
    }

    var alert = $('<div>', {
      'class': alertClass,
      'role': 'alert'
    });

    var text = $('<span>', {
      'class': 'alert-message',
      'html':  message
    });

    if(showClose) {
      alert.prepend(closeButton);
    }

    alert.prepend(text);

    var id = $(document).find('.alert').length;
    ++id;
    alert.attr('id', 'alert-{0}'.format(id));

    // insert to
    switch (insertMethod) {
      case 'prepend': container.prepend(alert);
        break;

      case 'append' : container.append(alert);
        break;

      case 'before' : container.before(alert);
        break;

      case 'after' :  alert.insertAfter(container);
        break;

      default: alert.insertAfter(container);
    }

    alert = $('#{0}'.format(alert.attr('id')));

    alert.slideDown(600, function (){
      // close alerts automatically
      if(undefined !== delay && null != delay) {
        window.setTimeout(function() {
          alert.slideUp(600, function() {
            alert.alert('close');
          });
        }, delay);
      }
    });

    return alert;
  };

  /**
   * Add tooltip to element.
   *
   * @param {String} [title]
   * @param {String} [type]
   * @param {String} [effect]
   * @param {String} [position]
   */
  jQuery.fn.addTooltip = function (title, type, effect, position) {

    var defaultType     = 'default';
    var defaultEffect   = 'fade';
    var defaultPosition = 'top';
    var defaultTitle    = 'ToolTip';

    var template = '<div class="tooltip tooltip-{0} {1} {2} in"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

    $.each($(this), function () {

      var el = $(this);

      if(!el.is(':visible')) {
        return true;
      }

      var elementDataType     = el.data('tooltip-type');
      var elementDataEffect   = el.data('tooltip-effect');
      var elementDataPosition = el.data('tooltip-position');
      var elementDataTitle    = el.data('tooltip-title');

      var currentType     = type     || (elementDataType     || defaultType);
      var currentEffect   = effect   || (elementDataEffect   || defaultEffect);
      var currentPosition = position || (elementDataPosition || defaultPosition);
      var currentTitle    = title    || (elementDataTitle    || defaultTitle);

      el.siblings('.tooltip').remove();

      el.tooltip('destroy').tooltip({
        template: template.format(currentType, currentEffect, currentPosition),
        title: currentTitle,
        html: true
      });
    });

    return $(this);
  };

  /**
   * Bind values to form elements.
   *
   * @param {Object} data
   * @param {String} selectorType
   * @param {String} [name]
   */
  jQuery.formBindElements = function(data, selectorType, name) {
    name = name || null;
    var selectorTpl = '';

    switch (selectorType) {
      case 'class': selectorTpl = '.{0}';
        break;
      case 'id':    selectorTpl = '#{0}';
        break;
      case 'data':    selectorTpl = '[data-{1}="{0}"]';
        break;
      default :
        selectorTpl = false;
    }

    $.each(data, function(id, val) {
      var elementSelector = selectorTpl ? selectorTpl.format(id, name) : id;
      var element = $(elementSelector);

      if(element.length) {
        element.val(val);
      }
    });
  };

  /**
   * Add loading state to button.
   *
   * @param {String} type Possible values are "loading" and "reset"
   * @returns {*|HTMLElement}
   */
  jQuery.fn.buttonLoading = function(type) {
    var button     = $(this);
    var isDisabled = 'reset' != type;

    button.button(type);
    button.prop('disabled', isDisabled);

    return button;
  };

  /**
   * Pass twitter devices types ("xs", "xm", "md", "lg").
   * If device have passed type(s), return true, otherwise - false.
   *
   * @returns {boolean}
   */
  jQuery.checkDeviceType = function() {
    var args = arguments;
    var detected = false;

    $.each(args, function() {
      if($('body').hasClass('screen-{0}'.format(this))) {
        detected = true;
        return false;
      }
    });

    return detected;
  };

  /**
   * Provide to scroll screen to element.
   *
   * @param {int}      [time] Animation time in ms. Default time is 500ms.
   * @param {int}      [offsetTop]
   * @param {function} [callback]
   *
   * @returns {*|HTMLElement}
   */
  jQuery.fn.scrollToElement = function(time, offsetTop, callback) {
    var el = $(this);
    time      = time || 500;
    offsetTop = offsetTop || 0;
    callback  = 'function' == typeof callback ? callback : function () {};

    if(0 == el.length) {
      return el;
    }

    $('html, body').animate({
      scrollTop: el.offset().top + offsetTop
    }, time, callback);

    return el;
  };

  /**
   * Merge jQuery object to one object.
   *
   * @param {Array} objects
   */
  jQuery.mergeJQueryObjects = function (objects) {
    return $($.map(objects, function(el){return el.get();}));
  };

  /**
   * Filter elements by data name and value
   * Working with  jQuery.data(..) setter
   *
   * @param {String} prop
   * @param {String|Array} [val]
   * @returns {*}
   */
  $.fn.filterByData = function (prop, val) {
    var el = $(this);

    if (typeof val === 'undefined') {
      return el.filter(function() {
        return 'undefined' !== typeof $(this).data(prop);
      });
    }
    // 15374

    return el.filter(function() {
      return val instanceof Array ? -1 !== $.inArray($(this).data(prop), val) : val == $(this).data(prop);
    });
  };

  /**
   * Remove classes by prefix
   *
   * @param {String} prefix
   * @returns {jQuery}
   */
  $.fn.removeClassPrefix = function(prefix) {
    this.each(function(i, el) {
      var classes = el.className.split(" ").filter(function(c) {
        return c.lastIndexOf(prefix, 0) !== 0;
      });
      el.className = $.trim(classes.join(" "));
    });
    return this;
  };

  /**
   * Reset form data.
   *
   * @param {String[]} [exclude]
   */
  $.fn.resetForm = function(exclude) {
    exclude = exclude || [];
    var el  = $(this);

    // reset text fields.
    var elements = el.find('input[type=text], input[type="email"], input[type="password"], textarea, select');

    $.each(elements, function() {
      var element = $(this);

      if(-1 !== $.inArray(element.attr('name'), exclude)) {
        return true;
      }

      element.val('');

      // select boxes
      if('select' == element.prop('tagName').toLowerCase()) {
        // un-select
        element.find('option:selected').prop('selected', false);

        // select first
        element.find('option:first').prop('selected', true);
      }
    });
  };

  /**
   * Lock form fields
   *
   * @param {Boolean} state
   * @param {String[]} [exclude]
   */
  $.fn.lockForm = function(state, exclude) {
    var el = $(this);

    // lock form fields.
    var elements = el.find('input[type=text], input[type="email"], input[type="password"], textarea, select');

    $.each(elements, function() {
      var element = $(this),
          tag     = element.prop('tagName').toLowerCase()

      if(-1 !== $.inArray(element.attr('name'), exclude)) {
        return true;
      }

      if('select' == tag) {
        var pe = state ? 'none' : 'auto';

        element.css('pointer-events', pe);

        return true;
      }

      element.prop('readonly', state);
    });
  };

  /**
   * Populate form elements with selected option.
   * // todo@alexbuturlakin: need merge this function with $.fn.populateDefaultData
   * @param {jQuery}  option
   * @param {String[]} exclude
   */
  $.fn.populateDefaultDataSelect = function(option, exclude) {
    exclude = exclude || [];
    var el       = $(this),
        elements = option.data('default-elements');

    if(typeof elements === typeof undefined || false == elements) {
      return false;
    }

    // reset form
    el.resetForm(exclude);

    // update data
    var data = elements.split('||');

    $.each(data, function() {
      var params = this.split('::');

      // check that data has right format
      if(false == Array.isArray(params) || 0 == params.length) {
        return true;
      }

      // check in excluded elements
      if(-1 !== $.inArray(params[0], exclude)) {
        return true;
      }

      // get element
      var element = el.find('[name="{0}"]'.format(params[0]));

      // no element found
      if(0 == element.length) {
        return true;
      }

      var tag = element.prop('tagName').toLowerCase();

      // if select or text input
      if(('select' == tag)) {
        element.val(params[1]);

        return true;
      }

      var type = element.attr('type');

      // no type
      if(typeof type === typeof undefined) {
        element.val(params[1]);

        return true;
      }

      // if text input
      if('input' == tag && -1 !== $.inArray(type.toLowerCase(), ['text', 'email'])) {
        element.val(params[1]);
      }

      // if radio
      if('input' == tag && 'radio' == type.toLowerCase()) {
        params[1] == element.val() ? element.prop('checked', true) : element.prop('checked', false);
      }

      // trigger event
      element.trigger('default-data-populated', [params[1], 'select']);
    });

    el.trigger('default-data-populated', [[], 'select']);
  };

  /**
   * Populate form elements with default data.
   *
   * @param {Boolean}  populate
   * @param {String[]} exclude
   */
  $.fn.populateDefaultData = function(populate, exclude) {
    exclude = exclude || [];
    var el  = $(this);

    // reset form
    if(false == populate) {
      el.resetForm(exclude);

      return el;
    }

    // or populate values
    el.find('[data-default]').each(function() {
      var element = $(this),
          data    = element.data('default'),
          tag     = element.prop('tagName').toLowerCase();

      // check in excluded elements
      if(-1 !== $.inArray(element.attr('name'), exclude)) {
        return true;
      }

      // if select or text input
      if(('select' == tag)) {
        element.val(data);

        return true;
      }

      var type = element.attr('type');

      // no type
      if(typeof type === typeof undefined) {
        element.val(data);

        return true;
      }

      // if text input
      if('input' == tag && -1 !== $.inArray(type.toLowerCase(), ['text', 'email'])) {
        element.val(data);
      }

      // if radio
      if('input' == tag && 'radio' == type.toLowerCase()) {
        data == element.val() ? element.prop('checked', true) : element.prop('checked', false);
      }

      // ??

      // trigger event
      element.trigger('default-data-populated', [data, 'checkbox']);
    });

    el.trigger('default-data-populated', [[], 'checkbox']);
  };

  /**
   * Get submit path for form.
   *
   * @return {String}
   */
  $.fn.getFormSubmitPath = function() {
    var form = $(this);

    // if not a form or form not have action.
    if('form' != form.prop('tagName').toLowerCase() || typeof undefined == typeof form.attr('action')) {
      return document.URL;
    }

    var url = form.attr('action');

    url =  rtrim(url, '/');
    url += window.location.search;

    return url;
  };

  /**
   * Page reload
   *
   * @param {{}} [query]
   */
  $.pageReload = function(query) {
    var url = window.location.href;

    if(undefined != query) {
      var queryArr = [];
      $.each(query, function(key, value) {
        queryArr.push('{0}={1}'.format(key, value));
      });

      if(queryArr.length > 0) {
        var queryStr = queryArr.join('&'),
            sep      = url.indexOf('?') > -1 ? '&' : '?';

        url += sep + queryStr;
      }
    }

    window.location.href = url;
  };

  /**
   * from here - http://stackoverflow.com/questions/1090948/change-url-parameters
   * @return {string}
   */
  $.updateUrlParam = function(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) {
      var tmpAnchor = additionalURL.split("#");
      var TheParams = tmpAnchor[0];
      TheAnchor = tmpAnchor[1];
      if(TheAnchor) {
        additionalURL = TheParams;
      }

      tempArray = additionalURL.split("&");

      for (var i=0; i<tempArray.length; i++) {
        if(tempArray[i].split('=')[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    } else {
      var tmpAnchor = baseURL.split("#");
      var TheParams = tmpAnchor[0];
      TheAnchor     = tmpAnchor[1];

      if(TheParams) {
        baseURL = TheParams;
      }
    }

    if(TheAnchor) {
      paramVal += "#" + TheAnchor;
    }

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  };

  /**
   * From here - http://stackoverflow.com/a/1634841/1156253
   *
   * @param {String} url
   * @param {String} parameter
   */
  $.removeUrlParam = function(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length>=2) {

      var prefix= encodeURIComponent(parameter)+'=';
      var pars= urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i= pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  };

  /**
   * Show simple ajax modal
   *
   * @param {string}   path
   * @param {function} callback
   * @param {{}}       params
   */
  $.showXHRModal = function(path, callback, params) {
    callback = callback || function() {};
    params   = params || {};

    var options = {
      type:    'iframe',
      padding: 0
    };

    options = $.merge(options, params);

    $.get(path, function (response) {
      // user not loggined
      if (3 == response.status) {
        window.location = Storage.getData('app_url') + 'user/login';

        return;
      }

      // on error
      if(0 == response.status) {
        return;
      }

      options.content   = response.html;
      options.afterShow = function() { callback.call(this, params, response) };

      $.fancybox.open(options);
    });
  };

  /**
   * Show error in modal window.
   *
   * @param {String} message
   */
  $.showError = function(message) {
    var html = '<div class="modal-error"><div class="modal-header"><h3>{0}</h3></div><div class="modal-body">{1}</div></div>';

    $.fancybox.open({
      type:    'iframe',
      padding: 0,
      // autoSize: false,
      // width:   '400px',
      content: html.format($.translate('Error!'), message)
    });
  };

  /**
   * Show success modal window
   *
   * @param {String}         title
   * @param {String}         text
   * @param {String|Boolean} [destination]
   * @param {Boolean}        [disableRedirect]
   */
  $.showSuccess = function (title, text, destination, disableRedirect) {
    disableRedirect = disableRedirect || false;

    var html  = '<div class="modal-ok">',
        head  = '<div class="modal-header"><span class="UISectionTitleSummary UILabelIconValid">{0}</span></div>'.format(title),
        body  = '<div class="modal-body">{0}</div>'.format(text),
        foot  = '<div class="modal-footer"><button class="btn btn-primary close-window">{0}</button></div>'.format($.translate('Close'));

    html = html + head + body + foot + '</div>';

    var redirect = function() {
      if(disableRedirect) {
        return true;
      }

      if(typeof undefined === typeof destination) {
        window.location.href = window.location.href;
      } else {
        window.location.href = destination;
      }
    };

    $.fancybox.open({
      content: html,
      padding: 0,
      type: 'iframe',
      afterShow: function () {
        var btn = $('button.close-window');
        btn.click(function(){
          $.fancybox.close();
          redirect();
        });
      },
      afterClose: function () {
        redirect();
      }
    });
  };
})(jQuery);
